import React, { useEffect, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { fetchResidueTrace } from '../../../slices/thunks';
import { clearResidueTrace } from '../../../slices/residueTrace/reducer';
import TraceabilityPanel from './TraceabilityPanel';
import { folioLabel } from './traceUi';

const selectTraceForHeader = createSelector(
	state => state.ResidueTrace,
	rt => ({
		trace: rt.trace,
		traceLoading: rt.traceLoading,
	})
);

/**
 * @param {{
 *   isOpen: boolean,
 *   toggle: () => void,
 *   entityId: string | null,
 *   title?: string,
 * }} props
 */
const TraceabilityModal = ({ isOpen, toggle, entityId, title }) => {
	const dispatch = useDispatch();
	const { trace, traceLoading } = useSelector(selectTraceForHeader);

	useEffect(() => {
		if (!isOpen || !entityId) return;
		dispatch(clearResidueTrace());
		dispatch(
			fetchResidueTrace({
				entityId,
				max_depth: 10,
				include_movements: true,
			})
		);
	}, [isOpen, entityId, dispatch]);

	useEffect(() => {
		if (!isOpen) dispatch(clearResidueTrace());
	}, [isOpen, dispatch]);

	const headerTitle = title || 'Trazabilidad de la guía';

	const folioSubtitle = useMemo(() => {
		if (traceLoading || !trace || !trace.guide) return null;
		const f = folioLabel(trace.guide);
		return f || null;
	}, [trace, traceLoading]);

	return (
		<Modal
			isOpen={isOpen}
			toggle={toggle}
			size='lg'
			scrollable
			centered
			className='border-0'
			modalClassName='modal fade zoomIn'
		>
			<ModalHeader toggle={toggle}>
				<div className='d-flex flex-column'>
					<span>{headerTitle}</span>
					{folioSubtitle && (
						<span className='text-muted fw-normal fs-14 mt-1'>
							Folio <span className='text-body fw-semibold'>{folioSubtitle}</span>
						</span>
					)}
				</div>
			</ModalHeader>
			<ModalBody>
				{entityId ? (
					<TraceabilityPanel entityId={entityId} />
				) : (
					<p className='text-muted mb-0'>Sin identificador para consultar.</p>
				)}
			</ModalBody>
		</Modal>
	);
};

export default TraceabilityModal;
